import {makeAutoObservable, reaction} from 'mobx';
import * as Api from '@/utils/api/api';

const provinceList = [];
const cityList = [];
const districtList = [];

class Company2Store {
    name = '';
    code = '';
    person = '';
    idNumber = '';
    idPictureList = [];
    provinceId = 0;
    cityId = 0;
    districtId = 0;
    currentProvinceId = 0;
    currentCityId = 0;
    currentDistrictId = 0;
    detailedAddress = '';
    createDate = null;
    termStart = null;
    termEnd = null;
    termEndIsInfinite = false;
    registeredCapital = '';
    scope = '';
    license = null;
    licenseUrl = '';
    phone = '';
    emergencyPerson = '';
    emergencyPhone = '';
    provinceList = provinceList;
    cityList = cityList;
    districtList = districtList;

    constructor() {
        makeAutoObservable(this)
    }

    get createDateData() {
        if (!this.createDate) {
            return undefined;
        } else {
            return this.createDate.valueOf();
        }
    }

    get termStartData() {
        if (!this.termStart) {
            return undefined;
        } else {
            return this.termStart.valueOf();
        }
    }


    get termEndData() {
        if (this.termEndIsInfinite) {
            return -1;
        } else if (!this.termEnd) {
            return undefined;
        } else {
            return this.termEnd.valueOf();
        }
    }


    get licenseData() {
        if (this.license) {
            return [this.license];
        } else {
            return undefined;
        }
    }


    get areaData() {
        let cityList = this.cityList.map((item, i) => {
            if (item.value === this.currentCityId) {
                item.children = this.districtList;
            }

            return item;
        });

        let provinceList = this.provinceList.map((item, i) => {
            if (item.value === this.currentProvinceId) {
                item.children = cityList;
            }

            return item;
        });

        return provinceList;
    }

    fetchProvinceList() {
        Api.provinceList().then(list => {
            this.provinceList = list.map(item => {
                const {id: value, name: label} = item;

                return {value, label};
            });

            if (this.provinceList.length > 0) {
                this.currentProvinceId = this.provinceList[0].value;
            }

            this.currentCityId = 0;
            this.currentDistrictId = 0;
        });
    }

    fetchCityList({parentId}) {
        Api.areaList({parentId}).then(list => {
            this.cityList = list.map(item => {
                const {id: value, name: label} = item;
                return {value, label};
            });

            //   this.provinceList.forEach((item, i) => {
            //     if (item.value === parentId) {
            //       item.children = this.cityList;
            //     }
            //   });

            if (this.cityList.length > 0) {
                this.currentCityId = this.cityList[0].value;
            }
            this.currentDistrictId = 0;
        });
    }

    
    async fetchDistrictList({parentId}) {
        await Api.areaList({parentId}).then(list => {

            this.districtList = list.map(item => {
                const {id: value, name: label} = item;
                return {value, label};
            });

            //   this.cityList.forEach((item, i) => {
            //     if (item.value === parentId) {
            //       item.children = this.districtList;
            //     }
            //   });

            if (this.districtList.length > 0) {
                this.currentDistrictId = this.districtList[0].value;
            }
        });
    }
}

let store = new Company2Store();

/**
 * 获取城市列表
 */
reaction(
    () => store.currentProvinceId,
    currentProvinceId => {
        if (currentProvinceId > 0) {
            store.fetchCityList({parentId: currentProvinceId});
        }
    }
);

/**
 * 获取区域列表
 */
reaction(
    () => store.currentCityId,
    currentCityId => {
        if (currentCityId > 0) {
            store.fetchDistrictList({parentId: currentCityId});
        }
    }
);

export default store;
